<template>
  <div>
    <EventsGrid />
  </div>
</template>

<script>
import EventsGrid from "@/components/domain/event/EventsGrid.vue";

export default {
  components: {
    EventsGrid
  },
}
</script>

<style scoped>

</style>
